<a (click)="scrollUp()" class="position-fixed up-btn animate__animated animate__fadeInUp" [class.show-none]="!visible">^</a>